export interface SubscriptionLike {
  status?: string | null;
  trial_end?: string | null;
  trial_start?: string | null;
  current_period_end?: string | null;
  cancel_at_period_end?: boolean;
  [key: string]: any;
}

export function isTrialActuallyExpired(sub: SubscriptionLike | null | undefined): boolean {
  if (!sub) return false;
  return (
    sub.status === 'trialing' &&
    !!sub.trial_end &&
    new Date(sub.trial_end) < new Date()
  );
}

export function isSubscriptionActive(sub: SubscriptionLike | null | undefined): boolean {
  if (!sub) return false;
  if (sub.status === 'active') return true;
  if (sub.status === 'trialing' && !isTrialActuallyExpired(sub)) return true;
  if (sub.status === 'pending') return true;
  return false;
}

export function isSubscriptionExpiredOrCancelled(sub: SubscriptionLike | null | undefined): boolean {
  if (!sub) return false;
  if (sub.status === 'expired' || sub.status === 'cancelled') return true;
  if (isTrialActuallyExpired(sub)) return true;
  return false;
}
